import { authService } from "./auth.service";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8787";

interface ClientResult {
  id: string;
  name: string;
  email: string;
  phone: string | null;
}

interface InvoiceResult {
  id: string;
  number: string;
  total: number;
  status: string;
  date_issued: number;
  date_due: number;
  paid_amount: number;
  project_name: string | null;
}

interface LocationResult {
  id: string;
  name: string;
  location_type: string;
}

export const cashPaymentService = {
  async searchClients(q: string): Promise<ClientResult[]> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/payments/clients/search?q=${encodeURIComponent(q)}`
    );
    if (!result || result.error) {
      throw new Error(result?.error || "Error al buscar clientes");
    }
    return result.data || [];
  },

  async getClientInvoices(clientId: string): Promise<InvoiceResult[]> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/payments/clients/${clientId}/invoices`
    );
    if (!result || result.error) {
      throw new Error(result?.error || "Error al cargar facturas");
    }
    return result.data || [];
  },

  async getLocations(): Promise<LocationResult[]> {
    try {
      const result = await authService.fetchWithAuth(
        `${API_URL}/api/catalogs/financial_locations`
      );
      if (!result || result.error) return [];
      return result.data || [];
    } catch {
      return [];
    }
  },

  async uploadReceiptPhoto(
    file: File,
    clientId: string,
    invoiceId?: string
  ): Promise<string> {
    const presign = await authService.fetchWithAuth(
      `${API_URL}/api/client/receipts/presign-upload`,
      {
        method: "POST",
        body: JSON.stringify({
          filename: file.name,
          contentType: file.type,
          invoiceId,
        }),
      }
    );
    if (!presign || presign.error) {
      throw new Error(presign?.error || "Error al presign");
    }

    const uploadRes = await fetch(presign.data.upload_url, {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
    });
    if (!uploadRes.ok) throw new Error("Error al subir archivo");

    return presign.data.key;
  },

  async registerCashPayment(data: {
    clientId: string;
    invoiceId: string | null;
    projectId: string | null;
    amount: number;
    concept: string;
    locationId?: string;
    receiptPhotoUrl?: string;
    notes?: string;
  }): Promise<{
    paymentId: string;
    amount: number;
    newBalance: number;
    invoiceStatus: string | null;
  }> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/payments/cash`,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    );
    if (!result || result.error) {
      throw new Error(result?.error || "Error al registrar pago");
    }
    return result.data;
  },
};